import {
  NavLink as RouterLink,
  matchPath,
  useLocation,
  useNavigate
} from 'react-router-dom';
import PropTypes from 'prop-types';
import { Button, ListItem } from '@mui/material';
import React, { useState } from "react";
import { logout } from "../actions/auth";
import { useDispatch, useSelector } from "react-redux";
import * as Util from "../services/global.service";

const NavItem = ({
  icon: Icon,
  title,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  let logouts = () => {
    dispatch(logout()).then(
      (response) => {
        localStorage.removeItem("user");
        localStorage.removeItem("date");
        localStorage.removeItem("proxy");
        let pathTologin = response?.data?.data?.url
        if (Util.formatData(pathTologin, false) !== false) {
          const newWindow = window.open(pathTologin, '_self', 'noopener,noreferrer')
          if (newWindow) newWindow.opener = null
        } else {
          console.log('Navigate', 11);
          //navigate('/' + localStorage.getItem("site"), { replace: false });
          window.location.href = '/' + localStorage.getItem("site")
        }
      }
    ).catch((err) => {
      localStorage.removeItem('date');
      localStorage.removeItem('user');
      localStorage.removeItem("proxy");
      console.log('Navigate', 12);
      //navigate('/' + localStorage.getItem("site"), { replace: false });
      window.location.href = '/' + localStorage.getItem("site")
    })
  }
  return (
    <ListItem
      disableGutters
      sx={{
        display: 'flex',
        py: 0
      }}
    >
      <Button
        onClick={logouts}
        sx={{
          color: 'white.main',
          fontWeight: 'medium',
          justifyContent: 'flex-start',
          letterSpacing: 0,
          py: 1.25,
          textTransform: 'none',
          width: '100%',
          '& svg': {
            mr: 1
          }
        }}
      >
        {Icon && (
          <Icon size="20" />
        )}
        <span style={{
          fontSize: "16px", fontWeight: "500"
          // , textTransform: 'lowercase', display: "inline-block"
        }}>
          {title}
        </span>
      </Button>
    </ListItem>
  );
};

NavItem.propTypes = {
  icon: PropTypes.elementType,
  title: PropTypes.string,
};

export default NavItem;
